<template>
	<div>
		<tableBox  :url="'/Flat/SelLabCredit'"  :ifScreen="false" :ifSearch="true"  :disableSearch="true"   :columns="columns"></tableBox>
	</div>
</template>

<script>
	import tableBox from '../../../components/tableBox.vue'
	export default {
		name:'/core/integrityRecord',
		components: {
			tableBox
		},
		data() {
			return {

				columns: [
					
					
					{
							title: '操作人',
							dataIndex: 'realName',
							key: 'realName',
							scopedSlots:{
								customRender:'realName'
							},
							aligh:'center'
						},
						{
							title: '平台',
							key: 'labName',
							dataIndex: 'labName',
							
							aligh:'center'
						},
					{
						title: '处理人',
						dataIndex: 'handlerName',
						key: 'handlerName',
						aligh:'center',
						scopedSlots:{
							customRender:'handlerNames'
						}
						

					},
					{
						title: '总分',
						dataIndex: 'totalScore',
						key: 'totalScore',
						aligh:'center',
						scopedSlots:{
							customRender:'totalScore'
						}
					
					},
					{
						title: '条款',
						dataIndex: 'selLabCredit',
						key: 'selLabCredit',
						aligh:'center',
						scopedSlots:{
							customRender:'selLabCredit'
						},
						
					
					},
					
					{
						title: '备注',
						dataIndex: 'remarks',
						key: 'remarks',
						aligh:'center',
						scopedSlots:{
							customRender:'remarks'
						}
					
					},
				
					{
						title: '撤销',
						key: 'canceled',
						dataIndex: 'canceled',
						scopedSlots: {
							customRender: 'canceled'
						},
						aligh:'center'
					},
					{
						title: '操作时间',
						key: 'createTime',
						dataIndex: 'createTime',
						scopedSlots: {
							customRender: 'createTime'
						},
						aligh:'center'
					},
					// {
					// 	title: '操作',
					// 	dataIndex: 'instrumentCore',
					// 	scopedSlots: {
					// 		customRender: 'instrumentCore'
					// 	},
					// 	aligh:'center',
					// 	width:"130px"
					// },
				],
				
			}
		}
	};
</script>

<style>
</style>
